export const Roles_Display = {
  ACCOUNTS: 'Accounts',
  ALPHA_TESTER: 'Alpha Tester',
  BETA_TESTER: 'Beta Tester',
  BOOKING_ADMINISTRATOR: 'Booking Administrator',
  BOT: 'Bot',
  CGA_STAFF: 'CGA Staff',
  CGA_STUDENT: 'CGA Student',
  DEVELOPER: 'Developer',
  CASE_MANAGER: 'Student Success Manager',
  EXTERNAL_STUDENT: 'External Student',
  HEAD_TUTOR: 'Head Tutor',
  OPERATIONAL_SUPPORT: 'Operational Support',
  REVIEWER: 'Reviewer',
  STRATEGIST: 'Strategist',
  STUDENT: 'Student',
  SUBSCRIPTION_USER: 'Subscription User',
  SUPER_ADMIN: 'Super Admin',
  SYSTEM_ADMIN: 'System Admin',
  SYSTEM_OPERATOR: 'System Operator',
  TUTOR: 'Tutor',
  ALUMNI_STUDENT: 'Alumni Student',
  COMMUNITY_USER: 'Community User',
  COMMUNITY_MODERATOR: 'Community Moderator',
  COMMUNITY_BLOCKED_USER: 'Community Blocked User',
  COMMUNITY_ADMIN: 'Community Admin',
  INTEGRATION: 'Integration',
  RISE_STUDENT: 'Rise Student',
  CORE_STUDENT: 'Core Student',
  MEDVIEW_STUDENT: 'Medview Student',
  DULWICH_STUDENT: 'Dulwich Student',
  PARTNERSHIP_STUDENT: 'Partnership Student',
  ATHLETICS_STUDENT: 'Athletics Student',
  TUTORING_STUDENT: 'Tutoring Student',
};
